module.exports = __webpack_public_path__ + "media/bootstrap-icons/book-fill-1f9ca115.svg";